"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Discounts = void 0;
const discount_1 = require("./discount");
class Discounts {
    constructor(props) {
        this.props = props;
    }
    static createEmpty(tenantId) {
        return new Discounts({ tenantId, discounts: [] });
    }
    get id() {
        return `${this.tenantId}-discounts`;
    }
    get tenantId() {
        return this.props.tenantId;
    }
    get names() {
        return new Set(this.discounts.map((discount) => discount.name));
    }
    get namesSorted() {
        return [...this.names].sort();
    }
    get discounts() {
        return [
            ...this.props.discounts.map((props) => discount_1.Discount.fromProps(props)),
        ].sort((a, b) => a.name.localeCompare(b.name));
    }
    toProps() {
        return this.props;
    }
    static fromProps(props) {
        return new Discounts(props);
    }
    get isEmpty() {
        return this.props.discounts.length === 0;
    }
    mayAddDiscount(discount) {
        return !this.discountWithNameExists(discount.name);
    }
    discountWithNameExists(name) {
        return this.names.has(name);
    }
    findDiscountWithName(name) {
        var _a;
        return (_a = this.discounts.find((discount) => discount.name === name)) !== null && _a !== void 0 ? _a : null;
    }
    withDiscountAdded(discount) {
        if (!this.mayAddDiscount(discount)) {
            return this;
        }
        return Discounts.fromProps({
            ...this.toProps(),
            discounts: [
                ...this.discounts.map((d) => d.toProps()),
                discount.toProps(),
            ],
        });
    }
    withDiscountRenamed(oldName, newName) {
        const oldDiscount = this.findDiscountWithName(oldName);
        if (oldDiscount == null || this.discountWithNameExists(newName)) {
            return this;
        }
        const renamedDiscount = oldDiscount.withName(newName);
        return Discounts.fromProps({
            ...this.toProps(),
            discounts: [
                ...this.discounts
                    .filter((d) => d.name !== oldName)
                    .map((d) => d.toProps()),
                renamedDiscount.toProps(),
            ],
        });
    }
    withDiscountRemoved(name) {
        return Discounts.fromProps({
            ...this.toProps(),
            discounts: [
                ...this.discounts
                    .filter((d) => d.name !== name)
                    .map((d) => d.toProps()),
            ],
        });
    }
}
exports.Discounts = Discounts;
//# sourceMappingURL=discounts.js.map